<template>
  <div :class="{ 'right-menu__active': active }" class="right-menu">
    <div class="right-menu__content" @click="onClickMenu($event)">
      <div class="right-menu-header">
        <div class="right-menu-header__title">
          <form-data :input-model="searchInput" placeholder="Поиск" label="Поиск" fieldname="searchInput" @update="updateInput" />
        </div>
        <div class="right-menu-header__close-menu" @click="onCloseMenu"></div>
      </div>

      <div class="right-list">
        <ul>
          <template v-if="Array.isArray(list) && list.length > 0">
            <template v-for="(elem, index) in list">
              <li :key="index" :class="{ 'active-list-li': elem.active }" class="right-list-li" @click="onClickElem(elem)">
                <div class="slide-list-content">
                  <div class="mest-info">{{ getInfo(listKeys.mainInfo, elem) }}</div>
                  <!-- <div v-if="listKeys.mestInfo.length > 0" class="mest-info">{{ getInfo(listKeys.mestInfo, elem) }}</div> -->
                </div>
              </li>
            </template>
          </template>
          <li v-else class="right-list-li checkbox-less">
            <span>Нет данных</span>
          </li>
        </ul>
      </div>

      <div class="right-menu-footer">
        <div class="right-menu-footer__add-button right-menu-footer__add-button--with-list-count" @click="beforeClose">
          добавить
          <div class="list-count">{{ checkedList.length }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import FormData from "../forms/FormData";

export default {
  name: "RightMenu",
  components: { FormData },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    },
    slideElementUrl: {
      type: String,
      default: ""
    },
    activeList: {
      type: Array,
      default: () => []
    },
    fieldname: {
      type: String,
      default: ""
    },
    listKeys: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      list: [],
      searchInput: ""
    };
  },
  computed: {
    checkedList: {
      get() {
        return this.activeList;
      }
    }
  },
  mounted() {
    if (this.slideElementUrl) {
      this.getSource({ url: this.slideElementUrl }).then(response => {
        this.list = response.data.results.map(s => {
          const findElem = this.checkedList.find(el => el.id === s.id);
          if (findElem) {
            s.active = true;
          }
          return s;
        });
      });
    }

    setTimeout(() => {
      document.body.addEventListener("click", this.onBodyClick);
    }, 100);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  methods: {
    ...mapActions(["getSource"]),
    beforeClose() {
      this.$emit("update", {
        value: this.checkedList,
        fieldname: this.fieldname
      });
      this.onCloseMenu();
    },
    getInfo(arr, elem) {
      let string = "";
      if (arr.length > 1) {
        arr.map(s => {
          if (elem[s] === "EXPIRED") {
            string += `Истек -`;
          } else if (elem[s] === "VALID") {
            string += `Действующий -`;
          } else {
            string += `${elem[s]} -`;
          }
        });
        string = string.slice(0, string.length - 2);
      } else {
        string = elem[arr[0]];
      }
      return string || "нет информации";
    },
    updateInput(data) {
      this[data.fieldname] = data.value;
      this.getSource({
        url: this.slideElementUrl,
        params: { search: this[data.fieldname] }
      }).then(response => {
        this.list = response.data.results.map(s => {
          const findElem = this.checkedList.find(el => el.id === s.id);
          if (findElem) {
            s.active = true;
          }
          return s;
        });
      });
    },
    onClickElem(elem) {
      const elemIsActive = elem.active;
      this.list = this.list.map(s => {
        if (s.id === elem.id) {
          s.active = !elemIsActive;
        }
        return s;
      });
      if (elemIsActive) {
        this.checkedList = this.checkedList.filter(s => elem.id !== s.id);
      } else {
        this.checkedList.push(elem);
      }
    },
    onCloseMenu() {
      this.close();
    },
    onClickMenu(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.close();
    }
  }
};
</script>
